import { getProfile, updateProfile } from './profile'
import { changePassword } from './changePassword'
import { importByUri, uploadAvatar, deleteAvatar } from './avatar'
import { vehicle } from './vehicle'
import { spotted } from './spotted'
import { toggleLike } from './vote'
import { decode } from './decode'
import { dataone } from './dataone'
import { saveVehicle } from './saveVehicle'
import { saveSearch } from './saveSearch'
import { inquiries } from './inquiries'
import { myCruz } from './myCruz'

export const myCruzApi = {
  getProfile,
  updateProfile,
  changePassword,
  importByUri, uploadAvatar, deleteAvatar,
  spotted,
  toggleLike,
  vehicle,
  decode,
  dataone,
  saveVehicle,
  saveSearch,
  inquiries,
  myCruz,
}